module.exports = __webpack_public_path__ + "static/media/1-19.08d1afa0.mp3";